import React, { useEffect } from 'react'
import {
  downloadCircle,
  downloadDown,
  downloadUp,
  listIcon,
  users_2,
} from '../../../images'
import { RunnerUpHeader, StatusCard} from '../../../ui'
import Table from "../../../ui/datatable/DataTable";
import { useState } from 'react'
import Button from '../../../library/components/Button/index'
import { Link, NavLink } from 'react-router-dom'
import {
  useGetEpbCountCommonDataQuery,
  useGetEpbPinDownloadQuery,
  useGetEpbPinDownloadbyRoQuery,
} from '../../../services/finalizeGenerateViewTransmitService'
import { ALERT_TYPE_SUCCESS, VIEW } from '../../../constants/constants'
import './index.css'
import LeftMenu from '../../AnalyticsModule/Left'
import Card1 from '../../../ui/card/Card1'
import pop1 from '../../../dashboardicon/Population1.svg'
import { useSendSmsToRecordMutation } from '../../../services/sendSmsService'
import moment from "moment";
import { createAlert } from '../../../features/alert/alerts';
import { useDispatch } from 'react-redux';
import DownloadInstruction from '../../Dashboards/Dashboard/DownloadInstruction';
import RunnerUpHeaderNew from '../../../ui/runnerUpHeader/RunnerUpHeaderNew';

const roTableHeader = [
  'S. No.',
  'Unit ID',
  'Name',
  'Mobile No.',
  'Email',
  'e-PB Pending',
  'State',
  "End-Date & Time",
  'Action',
]
const columns = [
  {
    Header: "S. No.",
    accessor: "SNo",
  },
  {
    Header: "Record ID",
    accessor: "UnitID",
  },
  {
    Header: "Name",
    accessor: "Name",
  },
  {
    Header: "Mobile No.",
    accessor: "MobileNo",
  },
  {
    Header:  "Email",
    accessor: "email",
  },
  {
    Header:   "e-PB Pending",
    accessor: "e-PB PIN Pending",
  },
  {
    Header:   "State",
    accessor: "State",
  },
  {
    Header:   "End-Date & Time",
    accessor: "End-Date",
  },
  {
    Header: "Action",
    accessor: "Action",
  },
];
const columns2 = [
  {
    Header: "S. No.",
    accessor: "SNo",
  },
  {
    Header: "Record ID",
    accessor: "RecordID",
  },
  {
    Header: "Name",
    accessor: "Name",
  },
  {
    Header: "Mobile No.",
    accessor: "MobileNo",
  },
  {
    Header:  "Email",
    accessor: "email",
  },
  {
    Header:   "e-PB Pending",
    accessor: "e-PB Pending",
  },
  {
    Header:   "State",
    accessor: "State",
  },
  {
    Header:   "End-Date & Time",
    accessor: "End-Date",
  },
  {
    Header: "Action",
    accessor: "Action",
  },
];
const recordTableHeader = [
  'S. No.',
  'Record ID',
  'Name',
  'Mobile No.',
  'Email',
  'e-PB PIN Pending',
  'State',
  "End-Date & Time",
  'Action',
]

const EpbPinStatusByNodalOfficer = () => {
  const { data } = useGetEpbCountCommonDataQuery()
  const [skip, setSkip] = useState(true)
  const [totalNoOfRecords1, setTotalNoOfRecords1] = useState()
  const [totalNoOfRecords2, setTotalNoOfRecords2] = useState()
  const [skipByRo, setSkipByRo] = useState(true)
  const dispatch=useDispatch()
  const { data: epbPinDownloadData } = useGetEpbPinDownloadQuery('', { skip })
  const { data: epbPinDownloadDataByRo } = useGetEpbPinDownloadbyRoQuery('', {
    skip: skipByRo,
  })
  const [sendSmsToRecord,datap] = useSendSmsToRecordMutation()

  const [ePbPinDataForRecord, setEPbPinDataForRecord] = useState([])
  const [ePbPinDataForUnit, setEPbPinDataForUnit] = useState([])
  var endDate=moment(epbPinDownloadDataByRo?.payload?.endDate).format(
    'DD-MMMM-YYYY HH:mm A'
  );
  


  useEffect(() => {
    let dataForRecord = []
    epbPinDownloadDataByRo?.payload?.map((item, i) => {
      dataForRecord.push({
        'SNo': i + 1,
        'UnitID': item.userId,
        Name: item.userName,
        'MobileNo': item.userMobile,
        'email': item.userEmail,
        'e-PB PIN Pending': item.epbPending,
        State: item.stateName,
        "End-Date":moment(item.endDate).format(
          'DD-MMMM-YYYY HH:mm:ss A'
        ),
        Action: (
          <Button
            value="Send Sms"
            onClick={() => {
              sendSmsToRecord({
                userId: item.userId,
                stateCd: item.stateCd,
                endDate: moment(item.endDate).format('YYYY-MM-DD HH:mm:ss'),
              })
                .unwrap()
                .then((res) => {
                  console.log(res);
                })
                .catch((err) => console.log(err))
            }}
            btnClass="btn-class"
          />
        ),
      })
      setEPbPinDataForRecord(dataForRecord)
      setTotalNoOfRecords1(epbPinDownloadDataByRo?.payload?.length)
    })
  }, [epbPinDownloadDataByRo])

  const onSuccess = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_SUCCESS,
        heading: "Success",
      })
    );
  };

  useEffect(()=>{
    if(datap.isSuccess){
      onSuccess(" Sms Sent ")
    }
  },[datap.isSuccess])

  useEffect(() => {
    let dataForUnit = []
    epbPinDownloadData?.payload?.map((item, i) => {
      dataForUnit.push({
        'SNo': i + 1,
        'RecordID': item.userId,
        Name: item.userName,
        'MobileNo': item.userMobile,
        'email': item.userEmail,
        'e-PB Pending': item.epbPending,
        State: item.stateName,
        "End-Date":moment(item.endDate).format(
          'DD-MMMM-YYYY HH:mm:ss A'
        ),
        Action: <Button value="Send Sms" btnClass="btn-class" 
        onClick={() => {
          sendSmsToRecord({
            userId: item.userId,
            stateCd: item.stateCd,
            endDate: moment(item.endDate).format('YYYY-MM-DD HH:mm:ss'),
          })
            .unwrap()
            .then((res) => {
              console.log(res);
            })
            .catch((err) => console.log(err))
        }} />
        
      })
    })
    setEPbPinDataForUnit(dataForUnit)
    setTotalNoOfRecords2(epbPinDownloadData?.payload?.length)
  }, [epbPinDownloadData])

  return (
    <LeftMenu>
      <div className="pin-status container">
        <RunnerUpHeaderNew title={'e-PB PIN Download Status'} />
        <div className="row record_statusCard">
          <div className="col-md-3">
            <StatusCard
              title={'Total Record'}
              count={data?.payload?.totalRecordCount}
              icon={listIcon}
              bgColor={'#FF87CA'}
            />
          </div>
          <div className="col-md-3">
            <StatusCard
              title={'Uploaded e-PB PIN'}
              count={data?.payload?.uploadedEpbPinCount}
              icon={downloadUp}
              bgColor={'#FF87CA'}
            />
          </div>
          <div className="col-md-3">
            <StatusCard
              title={'Downloaded e-PB PIN'}
              count={data?.payload?.downloadedEpbPinCount}
              icon={downloadDown}
              bgColor={'#B983FF'}
            />
          </div>
          <div className="col-md-3">
            <StatusCard
              title={'Pending e-PB PIN'}
              count={data?.payload?.pendingEpbPinCount}
              icon={downloadCircle}
              bgColor={'#EF4B4B'}
            />
          </div>
          <Link
            to=""
            className="button"
            onClick={() => {
              setSkipByRo(false)
            }}
          >
            {VIEW}
          </Link>
        </div>
        <label className="label" hidden={skip}>
          Pending e-PB Pin
        </label>
        {!skipByRo && (
          // <TableWork
          //   id=""
          //   theadData={recordTableHeader}
          //   tbodyData={ePbPinDataForRecord}
          //   anchorTagName=""
          //   anchorTagclassName="viewDetails"
          //   emptyMessage="No data found"
          //   pageSize={10}
          //   pagination={true}
          //   paginationClass={'text-right p-0'}
          // />
          <Table
          placeholder="Search"
          globalsearch={true}
          selectall={true}
          columns={columns}
          emptyMessage="No Record Found"
          data={ePbPinDataForRecord?.length === 0 ? [] : ePbPinDataForRecord}
          size={10}
          tableClassNameCheck="contenttable-eroll"
          pagination
          records
          gotopage
          rows
          numberrows={totalNoOfRecords1}
        />
        )}
       <RunnerUpHeaderNew title={'e-PB Download Status'} />
        <div className="row record_statusCard">
          <div className="col-md-3">
            <StatusCard
              title={'Total Unit'}
              count={data?.payload?.totalUnitCount}
              icon={users_2}
              bgColor={'#BFB051'}
            />
          </div>
          <div className="col-md-3">
            <StatusCard
              title={'Uploaded e-PB'}
              count={data?.payload?.uploadedEpbCount}
              icon={downloadUp}
              bgColor={'#5AA469'}
            />
          </div>
          <div className="col-md-3">
            <StatusCard
              title={'Downloaded e-PB'}
              count={data?.payload?.downloadedEpbCount}
              icon={downloadDown}
              bgColor={'#763857'}
            />
          </div>
          <div className="col-md-3">
            <StatusCard
              title={'Pending e-PB '}
              count={data?.payload?.pendingEpbCount}
              icon={downloadCircle}
              bgColor={'#6155A6'}
            />
          </div>
          <Link
            to=""
            className="button"
            onClick={() => {
              setSkip(false)
            }}
          >
            {VIEW}
          </Link>
        </div>
        <label className="label" hidden={skipByRo}>
          e-PB Pending for Download
        </label>
        {!skip && (
         
          <Table
          placeholder="Search"
          globalsearch={true}
          selectall={true}
          columns={columns2}
          emptyMessage="No Record Found"
          data={ePbPinDataForUnit?.length === 0 ? [] : ePbPinDataForUnit}
          size={10}
          tableClassNameCheck="contenttable-eroll"
          pagination
          records
          gotopage
          rows
          numberrows={totalNoOfRecords2}
        />
        )}
        {/* <NavLink className="nav-link2" to="/nodal/users">
          <Card1
            icon={pop1}
            head="UsersList"
            // text="User will be able to View the reports of their respective State"
          />
        </NavLink> */}
      </div>
      <DownloadInstruction />
    </LeftMenu>
  )
}

export default EpbPinStatusByNodalOfficer
